/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, CarCollectionFromJSON, CarCollectionToJSON, ContactPersonFromJSON, ContactPersonToJSON, } from './';
export function CollectorAdministratorFromJSON(json) {
    return CollectorAdministratorFromJSONTyped(json, false);
}
export function CollectorAdministratorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'applicationUserId': !exists(json, 'applicationUserId') ? undefined : json['applicationUserId'],
        'applicationUser': !exists(json, 'applicationUser') ? undefined : ApplicationUserFromJSON(json['applicationUser']),
        'carCollectionId': !exists(json, 'carCollectionId') ? undefined : json['carCollectionId'],
        'carCollection': !exists(json, 'carCollection') ? undefined : CarCollectionFromJSON(json['carCollection']),
        'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] === null ? null : json['addresses'].map(AddressFromJSON)),
        'contactPersonId': !exists(json, 'contactPersonId') ? undefined : json['contactPersonId'],
        'contactPerson': !exists(json, 'contactPerson') ? undefined : ContactPersonFromJSON(json['contactPerson']),
        'accountExpiresOn': !exists(json, 'accountExpiresOn') ? undefined : (json['accountExpiresOn'] === null ? null : new Date(json['accountExpiresOn'])),
    };
}
export function CollectorAdministratorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'applicationUserId': value.applicationUserId,
        'applicationUser': ApplicationUserToJSON(value.applicationUser),
        'carCollectionId': value.carCollectionId,
        'carCollection': CarCollectionToJSON(value.carCollection),
        'addresses': value.addresses === undefined ? undefined : (value.addresses === null ? null : value.addresses.map(AddressToJSON)),
        'contactPersonId': value.contactPersonId,
        'contactPerson': ContactPersonToJSON(value.contactPerson),
        'accountExpiresOn': value.accountExpiresOn === undefined ? undefined : (value.accountExpiresOn === null ? null : value.accountExpiresOn.toISOString()),
    };
}
